const sellerMap = {
  'Fannie Mae': new Set(['FNM']),
  'Bank of America': new Set([
    'BOT',
    'BVV',
    'BV7',
    'BV8',
    'BOD',
    'BVD',
    'BR3',
    'BRV',
    'BS1',
    'BS2',
  ]),
  Caliber: new Set(['CC8', 'CC9']),
  Carrington: new Set(['CSO', 'CSV', 'CS7', 'CS8']),
  'Cenlar FSB': new Set(['CE1', 'CE2']),
  Chase: new Set(['JHN', 'JHV', 'JN2']),
  Citi: new Set(['C2O', 'C2V', 'CV7', 'CV8']),
  CountryPlace: new Set(['CP2', 'CP3']),
  FlagStar: new Set(['FVS', 'FOS', 'FG1', 'FG2', 'FG3', 'FG4']),
  'Fay Servicing': new Set(['FO1', 'FV1']),
  GDCA: new Set(['GD1', 'GD2']),
  'M&T': new Set(['MT1', 'MT2']),
  Midfirst: new Set(['MFO', 'MFV', 'MF3', 'MF4', 'MF7', 'MF8']),
  Nationstar: new Set(['NR3', 'NR4', 'NTB', 'NV7', 'NVB', 'NOS', 'NVS', 'NV8']),
  'Nationwide Bank': new Set(['NWO', 'NWV']),
  'Ocwen Loan': new Set(['ONO', 'ONV']),
  'Pacific Union': new Set(['PUV', 'PUO']),
  'Penny Mac': new Set(['PM1', 'PM2']),
  'PNC Mortgage': new Set(['PNV', 'PNO', 'PN8']),
  'Quicken Loans': new Set(['QLO', 'QLV']),
  Regions: new Set(['RBO', 'RBV']),
  RoundPoint: new Set(['RPO', 'RPT']),
  'Select Portfolio Servicing': new Set(['SP8', 'SP9']),
  'US Bank': new Set(['USO', 'USV']),
  'US Bank Housing Authority': new Set(['US2']),
  'Vanderbilt Mortgage': new Set(['VM1', 'VM2']),
  'Wells Fargo': new Set(['WF1', 'WV1', 'WV7', 'WF2', 'WV2', 'WV8']),
}

const sellerCodesFor = (sellers = []) => {
  sellers = Array.isArray(sellers) ? sellers : [sellers]

  return sellers.reduce(
    (acc, s) => new Set([...acc, ...(sellerMap[s] || [])]),
    []
  )
}

const cwcotSellerCodes = sellerCodesFor([
  'Bank of America',
  'Caliber',
  'Carrington',
  'Cenlar FSB',
  'Chase',
  'Citi',
  'CountryPlace',
  'FlagStar',
  'Fay Servicing',
  'GDCA',
  'M&T',
  'Midfirst',
  'Nationstar ',
  'Nationwide Bank',
  'Ocwen Loan',
  'Pacific Union',
  'Penny Mac',
  'PNC Mortgage',
  'Quicken Loans',
  'Regions',
  'RoundPoint',
  'Select Portfolio Servicing',
  'US Bank',
  'US Bank Housing Authority',
  'Vanderbilt Mortgage',
  'Wells Fargo',
])

export default sellerMap
export { cwcotSellerCodes }
